import * as React from "react";
import { Context } from "./_context";
export const PasswordIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M22 19.5h-2v-15h2v15ZM6 10.057l1.919-1.37 1.162 1.627-2.362 1.685 2.362 1.688-1.162 1.627-1.92-1.372V16H4v-2.058l-1.918 1.371-1.162-1.627L3.279 12 .92 10.313 2.08 8.688 4 10.057V8h2v2.057Zm9 0 1.919-1.37 1.162 1.627-2.362 1.685 2.362 1.688-1.162 1.627-1.92-1.372V16h-2v-2.058l-1.918 1.371-1.162-1.627L12.279 12l-2.36-1.686 1.162-1.626L13 10.057V8h2v2.057Z", fill: "currentColor" }));
  return iconset[size];
};
PasswordIcon.iconId = "gCV6jm";
